import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none"
}
const _hoisted_2 = ["fill", "fill-opacity"]

import { PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PersonIcon18',
  props: {
    fill: {
      type: String,
      default: 'black',
    },
    fillOpacity: {
      type: String as PropType<'1' | '0.54'>,
      default: '0.54',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M12.0002 6.5C12.0002 8.1575 10.6577 9.5 9.00018 9.5C7.34268 9.5 6.00018 8.1575 6.00018 6.5C6.00018 4.8425 7.34268 3.5 9.00018 3.5C10.6577 3.5 12.0002 4.8425 12.0002 6.5ZM3 13.9999C3 12.0049 6.9975 10.9999 9 10.9999C11.0025 10.9999 15 12.0049 15 13.9999V15.4999H3V13.9999Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_2)
  ]))
}
}

})